var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-text-field", {
    directives: [{ name: "currency", rawName: "v-currency" }],
    ref: "input",
    attrs: {
      value: _vm.formattedValue,
      label: _vm.label,
      dense: _vm.dense,
      readonly: _vm.readonly,
      "error-count": _vm.errorCount(_vm.keyError),
      "error-messages": _vm.errors(_vm.keyError),
      error: _vm.hasErrors(_vm.keyError),
      "hide-details": "auto",
    },
    on: {
      input: function ($event) {
        return _vm.updateValue($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }